import Joi from 'joi';
const ideasBlockSchema = Joi.object({
  type: Joi.string().valid('ideasBlock').required(),
  code: Joi.string().allow('', null).optional(),
  columns: Joi.number().valid(2, 3, 4, 6).allow(null).optional(),
  mobileColumns: Joi.number().valid(1, 2).allow(null).optional(),
  showCardArrows: Joi.boolean().allow(null).optional(),
  cards: Joi.array().items(Joi.object({
    id: Joi.string().required(),
    title: Joi.string().allow('').required(),
    href: Joi.string().required(),
    image: Joi.string().allow('', null).optional()
  }).unknown(true)).required()
}).unknown(true);
export default ideasBlockSchema;